import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC8k6RS26sS9Z_-tnOkxYT2JJasIoxYNrw",
  authDomain: "school-erp-9bbc8.firebaseapp.com",
  projectId: "school-erp-9bbc8",
  storageBucket: "school-erp-9bbc8.firebasestorage.app",
  messagingSenderId: "519420851613",
  appId: "1:519420851613:web:1e0907755be99f20b56b74"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;